export const state = {
  accountId: '',
  loading: true,
  loadingId: false,
  isExternalAuth: false,
  assets: {},
  fields: {
    legal: [],
    natural: []
  },
  terms: '',
  position: '',
  userInfo: {},
  isApp: false,
  access_token: null,
  hidden_email: null,
  hidden_phone: null,
  user_email: '',
  contacts: null,
  smsChannel: false,
  request_id: '',
  message_sent: false,
  cooldown: 0,
  is_recover_sms: false,
  facebook_pixel_id: '',
  google_analytics_id: '',
  allowed_countries: [],
  uneditable_fields: [],
  selectedCountry: 'BRASIL',
  socialMedia: {},
  login_menu: false,
  delete_request: false,
  is_confirmed: false,
  show_delete_buttons: false,
  show_partial_delete_buttons: false,
  allowed_person_types_signup: [],
  allowed_modules: {},
  hotsiteLinks: [],
  finishScreenWhatsapp: {
    whatsapp_link: '',
    enable_whatsapp_link: false
  },
  appStores: {
    enable_apps: false,
    app_store_link: '',
    play_store_link: ''
  },
  currentCaptchaToken: null,
  signupTag: '',
  whatsappBots: [],
  whatsappTutorialSteps: [
    {
      icon: 'store',
      text: '<span class="highlight-content">Escolha sua loja favorita</span> e clique no botão ou leia o QR code.'
    },
    {
      icon: 'phone',
      text: '<span class="highlight-content">Envie a mensagem</span> para o nosso WhatsApp.'
    },
    {
      icon: 'favorite',
      text: '<span class="highlight-content">Adicione o nosso número</span> como contato e <span class="highlight-content">clique no link</span> para entrar na comunidade.'
    },
    {
      icon: 'check_circle',
      text: 'Tudo pronto! Agora você irá <span class="highlight-content">receber nossas ofertas</span>.'
    }
  ]
}
